export default {"src":"/bnb/_next/static/media/izumi.955b3b0f.svg","height":89,"width":85};